import { type ReactElement, type SVGProps } from 'react';

export const SurfaceTerraceIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m3.5 1.793 1.854 1.854-.708.707L4 3.707v13.086l.646-.646.708.707L3.5 18.708l-1.854-1.854.708-.707.646.646V3.707l-.646.647-.708-.707L3.5 1.793ZM22.208 20.5l-1.854 1.854-.707-.707.646-.647H7.207l.647.646-.707.708L5.293 20.5l1.854-1.854.707.708-.647.646h13.086l-.646-.646.707-.707 1.854 1.853Zm-8.901-18-6.6 6H13.5V17h1V8.5h6.793l-6.6-6h-1.386Zm-4.014 5 4.4-4h.614l4.4 4H9.293Zm-1.403 6h3.61v3.501h-1v-2.5H8V17H7v-2.94l-.985-3.94.97-.242.905 3.621Zm12.22 0H16.5v3.501h1v-2.5H20V17h1v-2.94l.985-3.94-.97-.242-.905 3.621Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
